module.exports = __webpack_public_path__ + "static/img/Tom_Mitchell_mobile.ddf6c1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Mitchell_mobile.jpg
// module id = SxhK
// module chunks = 0